import { createBrowserRouter } from '../../environment/browser-router';
import install from '../install';

export default createBrowserRouter(install);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-little-router/es/immutable/environment/browser-router.js
// module id = 1504
// module chunks = 0